module.exports = __webpack_public_path__ + "img/arrow_right_3.5c2910d8.svg";